<template>
  <v-dialog
    v-model="show"
    max-width="50vw"
    scrollable
    @click:outside="cancel"
  >
    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card-title class="justify-center text-h5">
        {{ label }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          class="multi-col-validation mt-4"
        >
          <v-row>
            <v-col cols="12">
              <p class="text--secondary mb-0">
                Есть в заказе блюдо из выбранных категорий — прибор кладётся сам, без
                кратности: хоть восемь сетов, палочки одни. Гость может прибавить до
                максимума — если заказ на компанию. В кассу уходит бесплатной строкой.
              </p>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="dishRkId"
                :items="dishOptions"
                :rules="[rules.required]"
                :error-messages="messages('dishRkId')"
                item-value="rkId"
                item-text="name"
                label="Прибор"
                hint="Из «Подарочного товара», вкладка «Приборы»"
                persistent-hint
                dense
                outlined
              >
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      код {{ item.code || '—' }} · {{ item.price }} сом
                      <span v-if="!item.isAvailable"> · недоступна</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="categoryKeys"
                :items="categoryOptions"
                item-value="key"
                item-text="name"
                label="К каким категориям"
                hint="Палочки — роллы и сеты, приборы — горячие блюда и салаты. Пусто — к любому заказу."
                persistent-hint
                multiple
                chips
                small-chips
                deletable-chips
                dense
                outlined
              >
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.path">
                      {{ item.path }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="quantity"
                :rules="[rules.required]"
                :error-messages="messages('quantity')"
                type="number"
                min="1"
                label="Кладём сами"
                hint="От числа блюд не зависит"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="maxQuantity"
                :rules="[rules.required]"
                :error-messages="messages('maxQuantity')"
                type="number"
                min="1"
                label="Максимум на корзину"
                hint="Гость прибавит сам, если заказ на компанию"
                persistent-hint
                dense
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="isEnabled"
                label="Правило включено"
                dense
                class="mt-1"
              ></v-switch>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="saveData"
              >
                Сохранить
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                class="mt-4"
                type="reset"
                @click="cancel"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import { errorMessages } from '@/helpers'

export default {
  name: 'ApplianceRuleForm',
  props: ['save', 'show', 'cancellation', 'label'],
  data: () => ({
    rules,
  }),
  computed: {
    ...mapFormHandlers('applianceRule/form', [
      'isEnabled',
      'dishRkId',
      'categoryKeys',
      'quantity',
      'maxQuantity',
    ]),
    ...mapState('applianceRule/form', ['dishOptions', 'categoryOptions', 'errors']),
  },
  watch: {
    show(value) {
      if (value && this.$refs.form) this.$refs.form.resetValidation()
    },
  },
  methods: {
    ...mapActions('applianceRule/form', ['resetForm']),
    messages(property) {
      return errorMessages(this.errors, property)
    },
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.save()
        this.resetForm()
      }
    },
  },
}
</script>
